import moment from "moment";
import { normalizeExpensesForState } from "../calc/expenses/logic/haklaiExpensesHelpers";

export const getDefaultHaklaiSoldPropertyDate = () => moment(new Date()).format("YYYY-MM-DD");

export const createInitialHaklaiCalc = ({ soldPropertyDate = getDefaultHaklaiSoldPropertyDate() } = {}) => ({
  preCalc: {
    sellerType: "single",
    soldPropertyDate,
    totalPropertyCost: null,
    hasZaban: false,
    ptorType: "none",
    hasTzinunOnPtor: false,
    wayOfGettingProperty: "purchase",
    acquisitionDetails: {
      deduDate: "",
      testatorPassingDate: "",
      testatorBoughtPropertyDate: "",
      amount: null,
      deduCurrency: "newShekel",
      hasRabinovich: false
    },
    parcelGush: null,
    parcelHelka: null,
    parcelAddressSearch: "",
    parcelLookupError: null
  },
  mainCalc: {
    propertyPartsData: {},
    expenses: normalizeExpensesForState([]),
    residentialRentalByPart: {},
    purchaseDepreciationByPart: {},
    purchaseDepreciationSelectionByPart: {},
    purchaseZabanAttributionByPart: {},
    prisa: { shouldTryPrisa: false, personsData: [] },
    kizuzIski: null,
    kizuzHoni: null,
    afkaa: false
  }
});

export const emptyInitialHaklaiCalc = createInitialHaklaiCalc({ soldPropertyDate: "" });

export const initialHaklaiManage = {
  dealDescription: "",
  hasEaaratAzhara: false,
  hasMasShevachReportsSubmitted: false,
  masShavach: false,
  masRechisha: false,
  haitelHashbacha: false
};
